export default class ConfigDto {
    constructor(data) {
        this._data = data;
    }

    get status() {
        return new ConfigStatusDto(this._data.status);
    }
}

export class ConfigStatusDto {
    constructor(data) {
        this._data = data;
    }

    /**
     * @returns {"live"|"maintenance"|"closed"}
     */
    get state() {
        return this._data.state;
    }

    /**
     * @returns {string}
     */
    get message() {
        return this._data.message;
    }
}